import { render } from "./MovementContent.vue?vue&type=template&id=221aa2d4"
import script from "./MovementContent.vue?vue&type=script&lang=js"
export * from "./MovementContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__